// THE CLIENT-OWNED UPGRADE SIGNAL (Ori's ruling, 2026-08-08): the
// content-addressed artifact cache serves a held body on a fingerprint match
// with ZERO network calls, so a browser that opened an older version can
// never learn a newer one exists — the closed-cache loop. The channel's
// cache-hit revalidation (one cheap `shape` ask; `{unchanged:true}` costs no
// bytes) marks the machine here when the world holds newer content, and the
// artifact CONTROL tab renders the deliberate Upgrade affordance (the cache
// replacement is a CLIENT feature — it lives beside permission/refs, never
// in the wrapper pane). The act stays the human's: nothing auto-replaces.
type Listener = () => void;

const upgradable = new Set<string>();
const listeners = new Set<Listener>();
let version = 0;

const emit = () => {
  version += 1;
  for (const listener of listeners) listener();
};

export const artifactUpgradeStore = {
  subscribe(listener: Listener): () => void {
    listeners.add(listener);
    return () => listeners.delete(listener);
  },
  // useSyncExternalStore snapshot — a monotonically increasing version so
  // any mark/clear re-renders subscribers.
  getSnapshot(): number {
    return version;
  },
  mark(machine: string): void {
    const id = String(machine || "");
    if (!id || upgradable.has(id)) return;
    upgradable.add(id);
    emit();
  },
  clear(machine: string): void {
    const id = String(machine || "");
    if (!upgradable.delete(id)) return;
    emit();
  },
  known(machine: string): boolean {
    return upgradable.has(String(machine || ""));
  },
};
